import { render, staticRenderFns } from "./CollaborativeTaskCreation.vue?vue&type=template&id=47f807f8&scoped=true"
import script from "./CollaborativeTaskCreation.vue?vue&type=script&lang=js"
export * from "./CollaborativeTaskCreation.vue?vue&type=script&lang=js"
import style0 from "./CollaborativeTaskCreation.vue?vue&type=style&index=0&id=47f807f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f807f8",
  null
  
)

export default component.exports